module.exports = __webpack_public_path__ + "static/media/Gift.1a517c19.gif";